var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.522 12.817h-2.183v-3.4c0-.804-.023-1.861-1.126-1.861-1.125 0-1.31.896-1.31 1.792v3.47H5.722V5.81h2.09v.965h.024c.298-.552 1.01-1.126 2.068-1.126 2.205 0 2.619 1.447 2.619 3.331zm-9.26-7.972C2.574 4.845 2 4.27 2 3.58c0-.69.574-1.264 1.264-1.264.689 0 1.263.575 1.263 1.264 0 .712-.551 1.264-1.263 1.264zm1.103 7.972H2.183V5.81h2.182zM14.085.295H.62a.618.618 0 0 0-.62.62v13.488c0 .321.276.597.62.597h13.487c.345 0 .62-.276.62-.62V.916a.653.653 0 0 0-.643-.62z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin);
export default __webpack_public_path__ + "static/media/logo-linkedin.3e7fcab91149090ed3ff8059af88e11f.svg";
export { ForwardRef as ReactComponent };